import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import { loginReducer } from "./redux/reducers/authReducers";
import { dashboardReducer, orderReducer, paymentOrderReducer } from './redux/reducers/DashboardReducer';
import { measurementDeleteReducer, measurementListReducer, QuotationListReducer, searchQuotationSuggestion, searchSuggestionsReducer } from './redux/reducers/measurementReducers';
import tagReducer, { dealerMatrixReducer, inventoryFabricsReducer, inventoryReducer, liftStyleInventoryReducer, orderSubmitReducer, productTypesReducer } from './redux/reducers/orderReducers';
import { userSettingsReducer, userSettingsUpdateReducer } from './redux/reducers/settingsReducers';


const reducer = combineReducers({
    dealerLogin: loginReducer,
    dashboard: dashboardReducer,
    payOrders: paymentOrderReducer,
    orders:orderReducer,
    measurementList:measurementListReducer,
    measurementDelete:measurementDeleteReducer,
    quotationList:QuotationListReducer,
    suggestionList:searchSuggestionsReducer,
    quotationSuggestions:searchQuotationSuggestion,
    ordertags:tagReducer,
    //inventory data
    inventoryByCategory: inventoryReducer,
    inventoryFabrics: inventoryFabricsReducer,
    liftStyleInventory: liftStyleInventoryReducer,
    //matrix data
    matrix:dealerMatrixReducer,

    orderSubmit: orderSubmitReducer,
    //setting states
    userSettings:userSettingsReducer,
    updateduserSettings:userSettingsUpdateReducer,
    productTypes: productTypesReducer,


})

//Getting the data from local storage
const dealerInfoFromStorage = localStorage.getItem('dealerInfo') ? JSON.parse(localStorage.getItem('dealerInfo')) : null

const initialState = {
    dealerLogin: { dealerInfo: dealerInfoFromStorage },
}

const middleware = [thunk]

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))

export default store